import { Indicator } from 'utils/models';

export enum HeartRhythmMeasurementDiagnosis {
  sinus_arrhythmia = 'sinus_arrhythmia',
  extrasystoles_trig_episode = 'extrasystoles_trig_episode',
  other = 'other',
  undiagnosable = 'undiagnosable',
  extrasystoles_isolated = 'extrasystoles_isolated',
  dubious_rhythm = 'dubious_rhythm',
  extrasystoles = 'extrasystoles',
  extrasystoles_trigeminy = 'extrasystoles_trigeminy',
  tachy_episode = 'tachy_episode',
  extrasystoles_frequent = 'extrasystoles_frequent',
  phone_incompatible = 'phone_incompatible',
  extrasystoles_big_episode = 'extrasystoles_big_episode',
  increased_hrv = 'increased_hrv',
  sinus = 'sinus',
  atrial_flutter = 'atrial_flutter',
  brady_episode = 'brady_episode',
  tachycardia = 'tachycardia',
  extrasystoles_bigminy = 'extrasystoles_bigminy',
  tachy_arrhytmia = 'tachy_arrhytmia',
  pacemaker_rhythm = 'pacemaker_rhythm',
  bradycardia = 'bradycardia',
  brady_arrhytmia = 'brady_arrhytmia',
  quality_to_low = 'quality_to_low',
  quality_too_low = 'quality_too_low',
  atrial_fibrillation = 'atrial_fibrillation',
  no_diagnosis = 'no_diagnosis',
}

export const HeartRhythmMeasurementDiagnosisMap: {
  [key in HeartRhythmMeasurementDiagnosis]: { indicator: Indicator };
} = {
  sinus: { indicator: Indicator.Normal },
  increased_hrv: { indicator: Indicator.Normal },
  atrial_fibrillation: { indicator: Indicator.Urgent },
  atrial_flutter: { indicator: Indicator.Urgent },
  extrasystoles_isolated: { indicator: Indicator.Normal },
  extrasystoles_frequent: { indicator: Indicator.Warning },
  extrasystoles_bigminy: { indicator: Indicator.Warning },
  extrasystoles_big_episode: { indicator: Indicator.Warning },
  tachycardia: { indicator: Indicator.Warning },
  tachy_episode: { indicator: Indicator.Warning },
  extrasystoles_trigeminy: { indicator: Indicator.Warning },
  extrasystoles_trig_episode: { indicator: Indicator.Warning },
  bradycardia: { indicator: Indicator.Warning },
  brady_episode: { indicator: Indicator.Warning },
  dubious_rhythm: { indicator: Indicator.Warning },
  other: { indicator: Indicator.Warning },
  quality_to_low: { indicator: Indicator.Quality },
  quality_too_low: { indicator: Indicator.Quality },
  phone_incompatible: { indicator: Indicator.Quality },
  pacemaker_rhythm: { indicator: Indicator.Quality },
  no_diagnosis: { indicator: Indicator.NoResult },
  sinus_arrhythmia: { indicator: Indicator.Normal },
  undiagnosable: { indicator: Indicator.NoResult },
  extrasystoles: { indicator: Indicator.Warning },
  tachy_arrhytmia: { indicator: Indicator.Warning },
  brady_arrhytmia: { indicator: Indicator.Warning },
};

export const DIAGNOSIS_REVIEW_LABELS: HeartRhythmMeasurementDiagnosis[] = [
  HeartRhythmMeasurementDiagnosis.sinus,
  HeartRhythmMeasurementDiagnosis.extrasystoles_isolated,
  HeartRhythmMeasurementDiagnosis.increased_hrv,
  HeartRhythmMeasurementDiagnosis.extrasystoles_frequent,
  HeartRhythmMeasurementDiagnosis.atrial_fibrillation,
  HeartRhythmMeasurementDiagnosis.extrasystoles_bigminy,
  HeartRhythmMeasurementDiagnosis.atrial_flutter,
  HeartRhythmMeasurementDiagnosis.extrasystoles_big_episode,
  HeartRhythmMeasurementDiagnosis.tachycardia,
  HeartRhythmMeasurementDiagnosis.extrasystoles_trigeminy,
  HeartRhythmMeasurementDiagnosis.tachy_episode,
  HeartRhythmMeasurementDiagnosis.extrasystoles_trig_episode,
  HeartRhythmMeasurementDiagnosis.bradycardia,
  HeartRhythmMeasurementDiagnosis.dubious_rhythm,
  HeartRhythmMeasurementDiagnosis.brady_episode,
  HeartRhythmMeasurementDiagnosis.other,
  HeartRhythmMeasurementDiagnosis.quality_to_low,
  HeartRhythmMeasurementDiagnosis.phone_incompatible,
  HeartRhythmMeasurementDiagnosis.pacemaker_rhythm,
];
